import { render, staticRenderFns } from "./CollectionIndex.vue?vue&type=template&id=c4d1a5a2&"
import script from "./CollectionIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports